module.exports = __webpack_public_path__ + "static/media/cirrus-dark.243a362e.svg";